import React from 'react';

const WarrentyPolicy = () => {
  return (
    <div>
      <>
        <div className="site-primary" id="main">
          <div className="site-content" id="content">
            <div
              data-elementor-type="wp-page"
              data-elementor-id={4852}
              className="elementor elementor-4852"
            >
              <section
                className="elementor-section elementor-top-section elementor-element elementor-element-a843b35 elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
                data-id="a843b35"
                data-element_type="section"
                data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
              >
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-cc1abff"
                    data-id="cc1abff"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-ab11398 elementor-widget elementor-widget-heading"
                        data-id="ab11398"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <style
                            dangerouslySetInnerHTML={{
                              __html:
                                "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-heading-title {\n                                                    padding: 0;\n                                                    margin: 0;\n                                                    line-height: 1\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title[class*=elementor-size-]>a {\n                                                    color: inherit;\n                                                    font-size: inherit;\n                                                    line-height: inherit\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-small {\n                                                    font-size: 15px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-medium {\n                                                    font-size: 19px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-large {\n                                                    font-size: 29px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-xl {\n                                                    font-size: 39px\n                                                }\n\n                                                .elementor-widget-heading .elementor-heading-title.elementor-size-xxl {\n                                                    font-size: 59px\n                                                }\n                                            "
                            }}
                          />
                          <h2 className="elementor-heading-title elementor-size-default">
                            Warranty Policy
                          </h2>
                          <a
                            className="btn partdo-btn mt-3"
                            href="https://motortiger.com/super-files/motortiger-warranty-policy.pdf"
                          >
                            Download Warranty Policy
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="elementor-section elementor-top-section elementor-element elementor-element-12a804a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="12a804a"
                data-element_type="section"
                data-settings='{"_ha_eqh_enable":false}'
              >
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8d68fee"
                    data-id="8d68fee"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-dddc321 elementor-widget elementor-widget-text-editor"
                        data-id="dddc321"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <style
                            dangerouslySetInnerHTML={{
                              __html:
                                "\n                                                /*! elementor - v3.22.0 - 26-06-2024 */\n                                                .elementor-widget-text-editor.elementor-drop-cap-view-stacked .elementor-drop-cap {\n                                                    background-color: #69727d;\n                                                    color: #fff\n                                                }\n\n                                                .elementor-widget-text-editor.elementor-drop-cap-view-framed .elementor-drop-cap {\n                                                    color: #69727d;\n                                                    border: 3px solid;\n                                                    background-color: transparent\n                                                }\n\n                                                .elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap {\n                                                    margin-top: 8px\n                                                }\n\n                                                .elementor-widget-text-editor:not(.elementor-drop-cap-view-default) .elementor-drop-cap-letter {\n                                                    width: 1em;\n                                                    height: 1em\n                                                }\n\n                                                .elementor-widget-text-editor .elementor-drop-cap {\n                                                    float: left;\n                                                    text-align: center;\n                                                    line-height: 1;\n                                                    font-size: 50px\n                                                }\n\n                                                .elementor-widget-text-editor .elementor-drop-cap-letter {\n                                                    display: inline-block\n                                                }\n                                            "
                            }}
                          />
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-e737fb1 elementor-widget elementor-widget-text-editor"
                        data-id="e737fb1"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            <b>MOTOR TIGER INC. (MT)</b> warrants all parts (unless
                            otherwise specified) as per the information communicated
                            to you by MT’s sales agent. Our used engine warranty is
                            limited to manufacturing defects of the following parts:
                            block, heads, pistons, crankshafts, camshafts, rockers,
                            and other internal components only. Our warranty does not
                            cover any attached accessory parts, such as switches,
                            sensors, cables, turbo, electronics, belts, hoses, water
                            pumps, manifolds, wire harnesses, valve covers, gaskets,
                            brackets, oil pan, flywheel etc.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            SHIPPING &amp; LABOR ARE NOT COVERED UNDER WARRANTY!
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-ca0c5a2 elementor-widget elementor-widget-text-editor"
                        data-id="ca0c5a2"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Diesel Engines: Injectors; High pressure oil pumps; High
                            pressure fuel injectors and any other accessories outside
                            the engine block are not covered under our warranty.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            DISCLAIMER
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-0d34785 elementor-widget elementor-widget-text-editor"
                        data-id="0d34785"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            MT is not responsible for installation or improper use of
                            any engine/transmission sold to a client, therefore the
                            following parts and circumstances are not covered by our
                            warranty:
                          </p>
                          <ul>
                            <li>
                              <b>
                                PROFESSIONAL INSTALLATION IS REQUIRED. WE DO NOT
                                PROVIDE TECHNICAL SUPPORT FOR INSTALLATIONS AND DO
                                HIGHLY RECOMMEND IF YOU ARE NOT FAMILIAR WITH THE SWAP
                                TO PLEASE CONSULT WITH A PROFESSIONAL MECHANIC. IF
                                CERTIFIED MECHANIC DOES NOT INSTALL THE
                                ENGINE/TRANSMISSION, WARRANTY IS VOID. NO QUESTIONS
                                ASKED.
                              </b>
                            </li>
                            <li>
                              All engines are warranted against cracked cylinder
                              blocks or heads, bad cam or crankshaft, excessive
                              smoking, and to be in good running order unless
                              otherwise stated.
                            </li>
                            <li>
                              The used engine you have purchased must have new oil and
                              filter installed upon installation.
                            </li>
                            <li>
                              You must provide for a qqqqnew tune up upon installation
                              of engine, (points, plugs, plug wires, timing
                              components, etc.). Also gaskets and seals should have
                              been checked or replaced. This warranty only extends to
                              internally lubricated parts and the housing on drive
                              train parts. It does not cover bolt on parts, manifolds,
                              fuel injections, oil pans, brackets, water pumps,
                              flywheels, sensors, wires, ignition gaskets, seals,
                              distributor, computers, etc.
                            </li>
                            <li>
                              Professional installation is required. We do not provide
                              technical support for installations and do highly
                              recommend if you are not familiar with the swap to
                              please consult with a professional mechanic. If
                              certified mechanic does not install the
                              engine/transmission, warranty is void.
                            </li>
                            <li>
                              Customer must perform oil system overhaul procedure.
                              (Flush oil system &amp; change oil pump). The loss of
                              engine as a result of insufficient amount of oil in the
                              engine or lack of oil pressure will void warranty
                            </li>
                            <li>
                              Transmissions are warranted to be in good working order
                              against slippage or shifting failures.
                            </li>
                            <li>
                              Transmissions must have new seals, filter, and new oil
                              installed upon installation into vehicle.
                            </li>
                            <li>
                              Vehicles which have MT engines and transmissions
                              installed must have proper capacity cooling systems and
                              be flushed upon installation.
                            </li>
                            <li>
                              Proper oil levels and cooling levels must be maintained
                              at all times for warranty to be valid.
                            </li>
                            <li>
                              Warranty is void if heat tabs are melted or removed.
                            </li>
                            <li>
                              All Deposits are taken in <b>"good faith"</b> and are
                              not refundable under any circumstances.
                            </li>
                            <li>
                              MT will not reimburse any labor charges on defective
                              parts installed. Reimbursement shall be for original
                              cost of merchandise plus any tax collected.
                            </li>
                            <li>
                              All warranty claims must be presented to an authorized
                              agent or manager of MT within a period of 30 days from
                              date of purchase for this warranty to be valid.
                            </li>
                            <li>
                              This warranty is not transferrable and does not cover
                              damage if parts are used in connection with racing
                              purposes or vehicles with racing equipment or damages by
                              accident or misuse.
                            </li>
                            <li>Improper installation will void warranty.</li>
                            <li>
                              30% handling charge on usable merchandise returned
                              within 30 days - no returns after 30 days - no returns
                              on "cut off" parts. $5.00 minimum purchase. No guarantee
                              and no refund on electrical parts.
                            </li>
                            <li>
                              MT does not assume responsibility for towing charges,
                              lay-up time, telephone, loss due to down time, cost of
                              lodging, cost of vehicle use, inconvenience, or car /
                              truck rental
                            </li>
                            <li>
                              All body parts, interior parts, wheels, &amp; suspension
                              are not under warranty. These parts are always sold “as
                              is.”
                            </li>
                            <li>
                              The loss of engine, if the engine is red lined or
                              competitively raced voids warranty.
                            </li>
                            <li>
                              Customer must perform oil system overhaul procedure.
                              (Flush oil system &amp; change oil pump). The loss of
                              engine as a result of insufficient amount of oil in the
                              engine or lack of oil pressure will void warranty.
                            </li>
                            <li>
                              Any labor for installation or removal of any defective
                              part of an engine/transmission is not covered under
                              warranty.
                            </li>
                            <li>
                              Customer must perform Timing overhaul. (Timing
                              belt/chain/tensioner). Any damage to the engine due to
                              improper installation will void warranty.
                            </li>
                            <li>
                              Swapping or removal of cylinder
                              head(s)/crank/rods/pistons/cam(s)/gears &amp; removal of
                              transmission casing voids warranty.
                            </li>
                            <li>
                              Loss caused by modification or forced induction
                              (Nitrous/Alcohol Injection/Turbo/Supercharger &amp;
                              Aftermarket ECU upgrades) for which the engine was not
                              designed will void warranty.
                            </li>
                            <li>
                              Customer must perform cooling system overhaul. Loss
                              caused by overheating of the engine, unless overheating
                              is the direct result of the failure of an internal part
                              of the engine.
                            </li>
                            <li>
                              Any tune-ups and adjustments in belts, hoses, filters,
                              emission control devices, spark plugs, etc. are not
                              covered under warranty.
                            </li>
                            <li>
                              Decrease in performance of any covered part due to
                              normal wear and tear, unless actual breakdown occurs. MT
                              will not be held responsible if the engine purchased
                              does not fit into the designated vehicle. Before
                              purchasing the engine/transmission, the customer must
                              verify that the engine will fit into said vehicle. We
                              will not be held responsible if incorrect engine is
                              purchased.
                            </li>
                            <li>$100.00 service charge on all returned checks</li>
                            <li>
                              All refused/returned orders will be charged 30% of the
                              item amount for restocking fee plus all original and
                              return freight charges back to our warehouse, no
                              exceptions.
                            </li>
                            <li>
                              MT is not responsible for damages occurring during
                              shipment of any engine, transmission, or part{" "}
                            </li>
                            <li>
                              Warranty claim reimbursement cannot exceed the total
                              cost of the part purchased.
                            </li>
                            <li>
                              Since our inventory is located at various supplier
                              facilities, delivery times may vary, but it normally
                              takes 7-14 BUSINESS days (excluding weekends and
                              holidays). Even though it’s uncommon but sometimes
                              delivery times may be affected due to unusual
                              circumstances that may require some additional time.
                            </li>
                            <li>
                              Residential deliveries or request for lift gate will
                              result in $250.00 additional shipping charge, unless
                              noted otherwise.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            DEFECTIVE ENGINE CLAIM PROCEDURE
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-78d2486 elementor-widget elementor-widget-text-editor"
                        data-id="78d2486"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            In the unlikely event of a Head/Block/Transmission being
                            defective, we will require the following to be emailed
                            only to us:
                          </p>
                          <ul>
                            <li>
                              MT will require a detailed written description (work
                              order) along with pictures of the described defective
                              part from a Certified Mechanic ONLY.
                            </li>
                            <li>
                              A copy of the Mechanic’s certification along with
                              his/her contact information must be provided. MT will
                              contact the Certified Mechanic to ensure that the
                              documents are legitimate. The Certified Mechanic may not
                              be the individual who bought the engine from MT ATTN:
                              Claims or email to or info@motortiger.com
                            </li>
                            <li>
                              Once required paperwork is emailed, we will make a
                              decision on whether we will provide a refund for the
                              damaged part(s) only or request for the
                              engine/transmission to be returned for a replacement.
                              Neither shipping charges nor labor are covered under
                              warranty. You must return the defective
                              engine/transmission complete with no parts missing. If
                              parts are missing, those parts will be removed from the
                              replacement engine/transmission prior to being shipped.
                            </li>
                            <li>
                              If you have any questions or concern regarding this
                              warranty or any other type of questions, please feel
                              free to contact us via email at info@motortiger.com. MT
                              reserves the right to change or modify this warranty at
                              any time. Warranty information will always be displayed
                              on the reverse side of our Supplier’s invoices
                            </li>
                          </ul>
                          <p>
                            Motor Tiger understands that using and sharing your
                            information is vital to you. Motor Tiger wants to make you
                            feel secure and comfortable doing business with us as part
                            of our dedication to customer service. Here are some
                            standards that Motor Tiger adheres to when it comes to
                            gathering and using your information, including your
                            Personal Information and our efforts to keep it private.
                            Motor Tiger retains the right to change this Privacy
                            Statement at its sole discretion.
                            <br />
                            <br />
                            This Privacy Statement explains how we collect, use,
                            protect, and disclose your information when you visit and
                            website at{" "}
                            <a href="https://motortiger.com/">motortiger.com</a>,
                            across the United States, or when you use any other
                            services. Then this Privacy Statement also educates you
                            about specific options and rights you have in relation to
                            your data and how to control your data privacy.
                            <br />
                            <br />
                            Please keep in mind that this Privacy Statement does not
                            apply to the practices of other parties, such as our
                            partners, third-party service providers, and/or
                            advertising, even if such services are branded as or
                            delivered on behalf of Motor Tiger. Other entities'
                            privacy rules govern information collected from you by
                            others, such as third-party websites that you access
                            through links on the Website. Please read the privacy
                            rules of such third parties carefully.
                            <br />
                            <br />
                            The Motor Tiger Website's data gathering and usage methods
                            are substantially identical to how Motor Tiger obtains
                            customer information when you visit the website. However,
                            there may be variations between how the App collects and
                            uses your information and how websites or stores gather
                            and use your information. These distinctions will be
                            highlighted throughout the policy
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            We Gather Information:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Deliver and enhance our Services, Motor Tiger may gather
                            personal information about you. The kinds of personal
                            information Motor Tiger may have collected in the previous
                            twelve months, and the sources from which that information
                            may have been obtained are described below.
                            <br />
                            <br />
                            "Personal Information" refers to data that identifies,
                            relates to, describes, is fairly capable of being
                            associated with, may be reasonably linked to, or could be
                            used to directly or indirectly identify a specific person
                            or household (or from those and other information either
                            in our possession or likely to come into our possession).
                            If that information may be used to identify you, your
                            home, or your device, it may also include additional
                            information related to your Personal Information, such as
                            Generic Information (defined below), location,
                            preferences, or interests.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Business Information:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Motor Tiger is a business-to-business solution that
                            assists our commercial customers in meeting their needs.
                            As a result, we gather a lot of information from our
                            clients about their businesses, such as their company's
                            name, address, zip code, phone number, email address,
                            financial account information to enable transactions,
                            vehicle details, and other business-related information.
                            Additionally, to fulfill an order or inquiry, Motor Tiger
                            may need to collect information about an individual's role
                            within the company, such as the individual's name, title,
                            location, phone number, email address, other contact
                            information, information related to a "Motor Tiger"
                            Account with the Website, and other information.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Personal Information:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            When you use our Services, we may collect the following
                            "Personal Information" about you: your name, address, zip
                            code, phone number, email address, gender, age, date of
                            birth, and information about your vehicle (such as your
                            Vehicle Identification Number ("VIN") and year). When you
                            buy from our website, Motor Tiger may collect your credit
                            card information and billing address; however, your
                            payment card information is securely transmitted to our
                            payment card processor and is not held by Motor Tiger.
                            When you create a personal "Account" with the Websites or
                            a "My Account" account inside the Apps, we will also
                            collect your email address and a specific password. We may
                            also gather data and information about your location.
                            <br />
                            Generic Information may include data about Website pages
                            visited and visit length, App usage, device information,
                            your IP address, browser or operating system information,
                            or other information about your contact with our Websites
                            or Apps. Generic Information may be used or combined in
                            ways that identify you, your firm, or your position within
                            it in some circumstances. In some cases, the information
                            will be classified as either Business Information or
                            Personal Information, depending on the circumstances.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Cookies and Tracking Data:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            The Websites and Apps may utilize third-party goods and
                            services, such as cookies and web beacons, to collect
                            anonymous traffic data. A cookie is a little bit of data
                            kept on your device that aids in recognition of you by
                            websites, apps, and various servers. Other tracking
                            technologies, such as pixels or transparent GIF files, may
                            be used by Motor Tiger and its third-party service
                            providers for app and website administration and user
                            tracking.
                            <br />
                            <br />
                            Some of the cookies we employ are "strictly required" for
                            our Websites and Apps to function properly. Others add to
                            the operation of our websites and apps but aren't
                            necessarily required. Some cookies help us enhance the
                            functionality of our Websites and Apps (for example, by
                            collecting analytic data), while others help us offer you
                            personalized services (like ads that you may be interested
                            in).
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            We use the following types of cookies:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            To improve our website's quality and the services we
                            provide, we gather a variety of information from other
                            technologies. For example, we may collect Usage Data and
                            other information about the device you use to access our
                            Apps and Websites, as well as information about your
                            operating system and/or mobile device type, browser type,
                            domain, and other system settings, as well as the language
                            your system uses and the country and time zone where your
                            device is located. The IP address of the device you use to
                            connect to the Internet may be recorded by us.
                          </p>
                          <p>
                            <b>Cookie Selections:</b>
                          </p>
                          <p>
                            You have complete control over how you wish to use or
                            allow cookies to be used on your devices. You may use your
                            browser or mobile device settings to reject or refuse all
                            cookies, get a notification when a cookie is delivered, or
                            limit otherwise which cookies your browser or mobile
                            device accepts. You may also change your settings and
                            erase any cookies currently saved on your device. To learn
                            how to control the placement and/or removal of cookies and
                            other technologies, check the instructions supplied by
                            your browser or mobile device maker. Limiting or blocking
                            the use of cookies and other technologies, on the other
                            hand, may limit or prevent you from performing some
                            transactions, using certain activities, or accessing
                            certain information on our Website.
                            <br />
                            <br />
                            Motor Tiger shares non-personally identifiable Generic
                            Information about website users with third parties to
                            monitor cross-device interaction and targeted advertising,
                            including on other websites. Motor Tiger accomplishes this
                            by combining cookie data with web beacons. When you visit
                            and interact with the Websites, Motor Tiger may also
                            utilize third-party organizations to offer advertising
                            services and/or collect certain information. During your
                            visit to the Websites and/or other websites, these
                            third-party companies may collect and use non-personally
                            identifiable Generic Information (click stream
                            information, browser type, time and date, subject of
                            advertisements clicked or scrolled over) to provide
                            advertisements about goods and services likely to be of
                            greater interest to you.
                            <br />
                            <br />
                            These third-party firms may use cookies and other
                            technologies to identify your browser to collect and store
                            information about your online browsing behavior, including
                            your websites and apps' activities. You can opt-out of
                            having non-personal information or cookies used to target
                            adverts to you by the third-party service providers and
                            altering your browser or device's cookie settings. These
                            third-party firms may use cookies and other technologies
                            to identify your browser to collect and store information
                            about your online browsing behavior, including your
                            websites and apps' activities. You can opt-out of having
                            non-personal information or cookies used to target adverts
                            to you by the third-party service providers and altering
                            your browser or device's cookie settings.
                            <br />
                            Personal Data Collected in the Previous 12 Months
                            <br />
                            <br />
                            Over the previous 12 months, Motor Tiger has not gathered
                            any additional sorts of Personal Information from our
                            customers and visitors.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            How Do We Gather Information About You?
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Motor Tiger obtains your information in various ways,
                            including information you provide, the information we
                            acquire from your use of our Services, such as our
                            Websites and Apps, and information we obtain from third
                            parties.
                            <br />
                            <br />
                            Information You Provide: We gather the information you
                            choose to share. To utilize some elements of our Apps and
                            Websites, complete your requests with us, or offer you
                            certain Services, we may ask you to give certain
                            information - including Personal Information. When you
                            purchase auto parts and accessories from our Websites, we
                            will ask for your name, address, and credit card
                            information. When you approach us with a question or
                            remark, we may ask for your name, email address, or other
                            contact information. If you make an account with us, we
                            may ask you to submit your name, email address, and phone
                            number and create a password. If you opt to join our
                            mailing list, you will be asked to submit your email
                            address. Motor Tiger will primarily gather Business
                            Information to fulfill orders placed by business clients.
                            <br />
                            <br />
                            Data Collected When You Use Our Services: We get specific
                            information about you via your use of our Services, such
                            as Website and other generic information. For example, we
                            may collect information about the device you use to log
                            into, access, and utilize our Websites when you use them.
                            Other Generic Information on how you use our Websites,
                            Apps, or other Services may be collected.
                            <br />
                            <br />
                            When you use our Website, we may ask for your location
                            information to give nearby store locations and certain App
                            features and Services. You can prevent location tracking,
                            but if you do not disclose your location, some features of
                            the Websites and Apps will not work properly.
                            <br />
                            <br />
                            Additional Generic Information: We may use other Generic
                            information, such as aggregate statistics, about how you
                            use our Websites, Apps, and other Services.
                            <br />
                            <br />
                            Other: We collect generic network information to ensure
                            optimal Website and App functioning improvement. Camera,
                            Photos, and Media Files: You may upload photos and images
                            from your smartphone to the Apps as part of your
                            experience. The Apps may need to access or alter your
                            camera, photo gallery, or other areas of your device that
                            store media files to do so.
                            <br />
                            <br />
                            Phone and Contacts: The Apps may ask for access to your
                            contacts on your smartphone. It may also need to use the
                            phone functionalities on your smartphone to make direct
                            calls and read phone status and identification.
                            <br />
                            <br />
                            Information We Collect from Other Sources / Third Parties:
                            We may collect information about you from third parties
                            that assist us in providing our Services. Our order
                            fulfillment and shipping partners, for example, may
                            provide us with information regarding your order or
                            product return. We may also gather information from our
                            marketing partners to provide you with information about
                            items we believe you might be interested in. Finally, we
                            may collect information about you, such as Generic
                            Information and Business Information, that does not
                            directly identify you but is used in a way that might turn
                            it into Personal Information. For example, a part
                            manufacturer or distributor may provide Motor Tiger
                            warranty or product recall information about a product you
                            purchased from us. To offer you associated services, we
                            may combine that generic information with your information
                            in our national warranty database or other systems.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            How We Collect Information for Business and Other Purposes
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Motor Tiger collects, processes, and utilizes your
                            information to provide you with Motor Tiger's Services. As
                            a result, we acquire information about you for a variety
                            of reasons, including
                          </p>
                          <ul>
                            <li>
                              To carry out a contract with you, such as processing and
                              completing your Motor Tiger orders placed on our
                              website, through our apps, or in one of our stores.
                            </li>
                            <li>
                              When you sign up for the Motor Tiger mailing list, or
                              for a "My Account" or a "Motor Tiger" account and choose
                              to receive special offers, promotions, news, surveys,
                              and correspondence from Motor Tiger Rewards, or when you
                              sign up for the Motor Tiger mailing list.
                            </li>
                            <li>
                              To make our business goals in connection to the services
                              we serve you easier. These operational reasons may
                              include, but are not limited to: performing duties
                              relating to the operation of our Services, such as our
                              Websites and Apps, such as ad placement and/or providing
                              personalized content to our users;
                            </li>
                            <li>
                              Maintenance and improvement of our Services, including
                              the Websites and Apps; detection of security events; and
                              debugging and correcting faults that cause our Websites,
                              Apps, or other Services to malfunction.
                            </li>
                          </ul>
                          <p>
                            Other than that, the collection is linked to offering our
                            Services to you. For example, we may gather the following
                            information about you:
                          </p>
                          <ul>
                            <li>
                              To enable you to interact with interactive parts of our
                              Services, such as our online "Chat Now!" tool.{" "}
                            </li>
                            <li>
                              To serve you, our fellow members, customers, and
                              visitors with customer service.{" "}
                            </li>
                            <li>
                              To obtain important data or analysis to improve our
                              services.{" "}
                            </li>
                            <li>
                              To keep track of how our services are being used.{" "}
                            </li>
                            <li>
                              To identify, prevent, and resolve technological
                              problems.{" "}
                            </li>
                            <li>
                              To assist you in locating Motor Tiger Stores in your
                              area.
                            </li>
                          </ul>
                          <p>
                            Unless you have opted not to receive such information, we
                            will send you news (for example, via a newsletter),
                            special offers, marketing or promotional materials, and
                            general information about other goods, services, and
                            events that we offer that are similar to those that you
                            have already purchased or enquired about, or that we
                            believe may be of interest to you. You can opt-out of
                            receiving any or all of these communications from us by
                            contacting us at the address below, or by clicking on the
                            "unsubscribe" links in the email messages.
                            <br />
                            <br />
                            To present you with personalized content on the Websites
                            and in email communications sent in conjunction with your
                            use of the Websites, such as ads tailored to your
                            demographics, interests, preferences, and purchase
                            history.
                            <br />
                            <br />
                            We may also use "automatically collected" information and
                            "cookie" information to: personalize our services, such as
                            remembering your information, so you don't have to
                            re-enter it during your visit or the next time you visit
                            the Websites or Apps; provide customized third-party
                            advertisements, content, and information; monitor and
                            analyze our effectiveness and third-party marketing
                            activities; monitor aggregate usage metrics such as total
                            number of visitors, pages viewed, and time spent on the
                            Websites or Apps; and monitor aggregate usage metrics
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            How We Share and Disclose Your Information
                          </h2>
                          <h3 className="elementor-heading-title elementor-size-default">
                            Why Do We Share Your Information?
                          </h3>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Motor Tiger may share customer Personal Information with
                            third parties that supply Motor Tiger with services and
                            products. The following are just a few examples of how
                            your information might be used:
                          </p>
                          <ul>
                            <li>
                              Purchase fulfillment - for example, we'll give the firms
                              that assist us to send your order to you. your name,
                              company name, and address. Information may also be
                              shared with our product providers.{" "}
                            </li>
                            <li>
                              Motor Tiger Gift Cards and Motor Tiger Merchandise
                              Credits can be redeemed.{" "}
                            </li>
                            <li>
                              Motor Tiger Rewards and other customer reward programs
                              are supported.{" "}
                            </li>
                            <li>
                              Direct mail and e-mail marketing are examples of
                              marketing activity.
                            </li>
                            <li>Cleaning, upkeep, and analysis of databases. </li>
                            <li>Improving the customer experience. </li>
                            <li>Management of warranties.</li>
                          </ul>
                          <p>
                            To investigate, safeguard against, and assist in
                            prosecuting people involved in or impacting Motor Tiger,
                            our Services, and/or our customers for harmful, deceptive,
                            fraudulent, or unlawful activities. Disclosures to law
                            enforcement, prosecutors, and other agencies may be made
                            in order to investigate possible criminal behavior or
                            other civil infractions. In response to a valid and
                            enforceable request by law enforcement, judicial, or other
                            public authorities, or in conjunction with an appropriate
                            legal duty.
                            <br />
                            <br />
                            Motor Tiger also collects, retains, and utilizes aggregate
                            data, such as demographics and statistical data, that does
                            not contain Personal Information. Third parties may access
                            and use this aggregate data to help Motor Tiger and its
                            suppliers better understand and serve our customers.
                            <br />
                            <br />
                            Motor Tiger participates in the Adobe Marketing Cloud
                            Device Co-op to better understand how you use our Websites
                            and Apps across many platforms and provide personalized
                            promotions.
                            <br />
                            <br />
                            There are two types of third parties who get personal
                            information: We share or otherwise disclose personal
                            information about persons and businesses with the
                            following kinds of third parties. Certain third parties
                            have access to your information only to carry out these
                            duties on our behalf, and they are prohibited from
                            disclosing or using it for any other purpose:
                          </p>
                          <ul>
                            <li>
                              Service / Fulfillment Providers: To support and help us
                              provide our Services to you, we use third-party
                              fulfillment, shipment, transportation, and/or delivery
                              providers, organizations, persons, and agents under
                              contract with Motor Tiger ("Service Providers"). Such
                              Service Providers assist us in assessing how our
                              Services are used or provided by performing activities
                              or functions on our behalf, providing fulfillment and
                              other services, or performing duties or functions on our
                              behalf. For example, to execute your orders with Motor
                              Tiger, we will share your name and address with product
                              suppliers and delivery firms. We supply our payment card
                              processors with the credit card information you submit
                              to use in-store or online to fulfill your order.
                            </li>
                            <li>
                              Your account information is shared with service
                              providers that assist us in running our Motor Tiger
                              Rewards and other customer reward programs. We also
                              share data with database and cloud storage companies
                              that assist us in maintaining our Website and other
                              services.
                            </li>
                            <li>
                              Other Motor Tiger Entities: Your information may be
                              shared or disclosed with other Motor Tiger entities.
                            </li>
                            <li>
                              Partners in Marketing: We may also share your
                              information with our marketing partners from time to
                              time to offer you information about our Services, such
                              as promotions or coupons. This information is often
                              anonymized to not directly identify you; nevertheless,
                              on occasion, we may share your Personal Information with
                              such Marketing Partners.
                            </li>
                          </ul>
                          <p>Type of data which you provide us:</p>
                          <ul>
                            <li>Your name, customer Ids </li>
                            <li>
                              Contact information (Phone number, mailing /physical
                              address){" "}
                            </li>
                            <li>Purchase history </li>
                            <li>Rewards, coupons </li>
                            <li>Cookies, usage data, IP address</li>
                            <li>Other information you choose to provide us</li>
                          </ul>
                          <p>
                            The data you provide us is used to provide service and
                            give to Motor Tiger’s service providers, Marketing
                            partners, and other motor tiger entities.
                            <br />
                            <br />
                            Personal Information Disclosed for Business Purposes
                            Categories: Motor Tiger is a business-to-business solution
                            for our corporate clients, not for individuals. As a
                            result, the bulk of information given is your Business
                            Information or Generic Information related to your
                            function at work. We may also disclose your Personal
                            Information for the abovementioned business objectives.
                            Most importantly, we must share your name, address,
                            payment information, the items you have requested to
                            purchase, and any other information related to your
                            product order with those Fulfillment Providers (our
                            payment card processor and our shipment, transportation,
                            and/or delivery providers) who are required to complete
                            your order.
                            <br />
                            <br />
                            To manage our Website, provide you with advertisements or
                            other marketing, or provide additional services, we may
                            need to disclose certain Generic Information, such as your
                            IP address and/or browser information. When Business
                            Information or Generic Information is used in a way that
                            properly identifies or links you to you, it is considered
                            Personal Information.
                            <br />
                            <br />
                            Personal Information Categories Sold: Motor Tiger does not
                            sell, rent, or lease any of its customers' personal or
                            business information to third parties. Motor Tiger does
                            not sell personal information about children under the age
                            of sixteen.
                            <br />
                            <br />
                            Please keep in mind that a "sale" of Personal Information
                            does not include situations in which such information is
                            shared as part of a merger, acquisition, or other
                            transaction involving all or part of our company. We may
                            transmit your Personal Information to a third party as
                            part of a merger or other business transaction if we sell
                            all or part of our business, make a sale or transfer of
                            assets, or are otherwise involved in a merger or other
                            business transaction. If such a transaction significantly
                            impacts how your Personal Information is processed, we
                            will tell you before it is implemented.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Data Retention
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Motor Tiger will keep your Business Information and
                            Personal Information for as long as is required for the
                            reasons stated in this Privacy Statement. We will keep and
                            use your Personal Information to the extent necessary to
                            comply with our legal obligations (for example, if we are
                            required by applicable laws to keep your data), resolve
                            disputes, and enforce our legal agreements and policies,
                            as well as for other commercial, retail, and/or marketing
                            purposes.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Data Transfer
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Individuals in the United States of America are welcome to
                            use Motor Tiger's services. While our Websites and Apps
                            are open to everyone interested in Motor Tiger, we do not
                            sell or make any products, goods, or other services
                            available to anybody outside of the United States,
                            including the European Union. Your data, including
                            Personal Information, may be transmitted to and stored on
                            computers outside your state, province, country, or other
                            governmental jurisdiction, where data protection
                            regulations may differ from those in your jurisdiction. If
                            you choose to give information to us from outside the
                            United States, please be aware that we will transmit and
                            handle your data, including Personal Information, in the
                            United States. If you live in the European Union, you
                            should be informed that the United States' data protection
                            rules are not considered as strong as those in the EU.
                            Your submission of such information implies your approval
                            to that transfer.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Data Protection
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            We care about the security of your information but keep in
                            mind that no method of Internet transmission or computer
                            storage is entirely safe. While we endeavor to safeguard
                            your Personal Information against loss, misuse, and
                            unauthorized access, modification, disclosure, and
                            destruction using commercially reasonable techniques, we
                            cannot guarantee its ultimate security. By using our
                            Websites, Apps, and Services, you acknowledge that the use
                            of the Internet has inherent data security and privacy
                            limitations and that the security, integrity, and privacy
                            of any and all information exchanged between you and Motor
                            Tiger or between you and other related entities, cannot be
                            guaranteed.
                            <br />
                            <br />
                            We cannot guarantee or assure the security of any
                            information you send us or store, and you do so at your
                            own risk.
                            <br />
                            <br />
                            Any transactions you make with Motor Tiger, including
                            those made through our Websites and Apps, are processed by
                            third-party payment processors. The payment processors'
                            privacy statements and security procedures govern the
                            handling of those transactions. Motor Tiger is not
                            responsible for the data security procedures of
                            third-party payment processors.
                            <br />
                            <br />
                            "Do Not Track" Policy CalOPPA (California Online Privacy
                            Protection Act) signals.
                            <br />
                            <br />
                            Do Not Track ("DNT") is not something we support. Do Not
                            Track is a browser setting that lets websites know you
                            don't want to be monitored. You may enable or disable Do
                            Not Track by going to your browser's Preferences or
                            Settings page; you may enable or disable Do Not Track.
                            Consumers' online activity may be tracked over time and
                            across third-party Websites or online services. As we
                            discussed previously, you may update your browser's
                            settings to change its acceptance of tracking technology.
                            <br />
                            <br />
                            Third parties may acquire information about you.
                            Third-party reactions to do-not-track signals or other
                            similar methods are beyond our control. Third parties use
                            of data about you and their separate privacy rules
                            regulate their response to do-not-track signals.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Your Privacy Rights in California
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Under California law, residents have various rights
                            regarding their personal information. Motor Tiger seeks to
                            take reasonable efforts to allow California residents to
                            access, correct, modify, delete, or restrict the use of
                            their Personal Information and exercise other legal
                            rights. Individuals may be entitled to the following
                            benefits under applicable legislation, according to Motor
                            Tiger:
                          </p>
                          <ul>
                            <li>
                              Right to Access / Disclosure: to have access to your
                              Personal Information upon simple request - that is, you
                              may acquire a copy of such data, as well as other
                              information relevant to the collection or processing,
                              following receipt of a verified request.
                            </li>
                            <li>
                              Direct Marketer Disclosure: to have access to the
                              categories, names, and addresses of third parties who
                              have obtained Personal Information for direct marketing
                              purposes upon simple request and free of charge. For
                              further information, check the "Direct Marketers
                              Disclosure" section below.
                            </li>
                            <li>
                              Obtaining a list of The particular elements of your
                              Personal Information held by Motor Tiger;
                            </li>
                            <li>
                              Personal Information about you that has been collected,
                              sold to third parties, or shared to third parties for
                              commercial reasons;
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Personal Information categories sold in the last 12 months
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            The categories of third parties with whom Personal
                            Information is shared, sold, or disclosed for a business
                            purpose; the business or commercial purpose for collecting
                            or selling Personal Information; and the categories of
                            third parties with whom Personal Information is shared,
                            sold, or disclosed for a business purpose.
                            <br />
                            <br />
                            Right to Opt-Out of Personal Information Sales: Under the
                            California Consumer Privacy Act ("CCPA"), California
                            individuals have the right to refuse the sale of their
                            personal information in certain circumstances. However, as
                            previously stated, Motor Tiger does not sell personal
                            information.
                            <br />
                            <br />
                            Right to Deletion / "Right to be Forgotten": You have the
                            right to have your Personal Information deleted in certain
                            circumstances outlined by relevant data protection law and
                            upon receipt of a verified request. Right to Data
                            Portability: You have the right to request that we send
                            your Personal Information directly to a third-party
                            processor of your choice (where technically feasible; may
                            be limited to situations when processing is based on your
                            consent).
                            <br />
                            <br />
                            Right to Non-Discrimination: You have the right to
                            non-discrimination in the Services or quality of Services
                            you get from us for exercising your rights, as defined by
                            applicable law.
                            <br />
                            <br />
                            To exercise these rights, please contact us using the
                            information in the "Contact Us" section below. Before
                            responding to such inquiries, we may require you to verify
                            your identity
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Motor Tiger's Reward Programs
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            Individuals who participate in our "Motor Tiger Rewards"
                            rewards programs (collectively, "Rewards Programs") get
                            discounts and other advantages. You may make purchases to
                            earn credits and savings on future purchases when you sign
                            up for one of our Rewards Programs. We choose and
                            customize coupons, promotions, and other discounts or
                            offers based on what you buy and the stores and e-commerce
                            platforms you use. By registering for the program, you
                            agree to allow us to utilize your information to find the
                            most appropriate coupons, promotions, and other discounts
                            or offers for you.
                            <br />
                            <br />
                            We use the information we collect on our Motor Tiger
                            Rewards Program members to provide targeted incentives and
                            value to our customers, which helps us build relationships
                            with them and improve their entire experience. The value
                            we pass on to you through our Rewards program and other
                            incentives is not based on the value of the data you
                            supply to us in any manner. Other than providing you with
                            your Rewards, advantages, and other incentives, Motor
                            Tiger does not use your information for its reasons.
                            <br />
                            <br />
                            Our Rewards Programs are entirely optional. You can
                            opt-out of Rewards Programs after enrolling by logging
                            into your account or contacting us using the details
                            provided below. While we will not penalize you for
                            exercising your CCPA rights, we may be unable to give you
                            tailored coupons, promotions, or other discounts or offers
                            if you request the deletion of your personal information
                            linked with your Rewards Program account. We may no longer
                            be able to distribute or share customized coupon mailers
                            or personalized digital offers with you, for example.
                          </p>
                          <p>
                            <b>Disclosures for Direct Marketers</b>
                          </p>
                          <p>
                            In addition to the rights set out above, if you are a
                            California resident, you have the right to seek
                            information from us about how we share certain categories
                            of Personal Information with third parties for their
                            direct marketing purposes. You have the
                          </p>
                          <ul>
                            <li>
                              The kind of information we sent to third parties for
                              direct marketing reasons in the previous calendar year;
                            </li>
                            <li>
                              The names and addresses of the third parties who got the
                              information; and examples of the items or services
                              advertised if the nature of the third party's company
                              cannot be ascertained from their name
                            </li>
                          </ul>
                          <p>
                            Please submit enough information for us to evaluate if
                            this applies to you and attest to the fact that you are a
                            California resident to make such a request. For our
                            answer, please include a 6000 Big Pine Dr, Fontana, CA
                            92336 address. You can write to us at the address given to
                            make this request. Any such request must begin with the
                            phrase "California Privacy Rights Request" and contain
                            your name, street address, city, state, and ZIP code.
                            Please note that we are only obligated to reply to one
                            request per customer per year, and we are not compelled to
                            respond to requests sent to the address or toll-free
                            number shown below.
                            <br />
                            <br />
                            It's worth noting that responsive material may come in a
                            set format that isn't tailored to you.
                          </p>
                          <p>
                            <b>Your Options</b>
                          </p>
                          <p>
                            While Motor Tiger encourages you to use the personalized
                            features available on the Websites, you can access the
                            majority of Motor Tiger's online services without
                            registering. You may unsubscribe from the Motor Tiger
                            mailing list at any time by clicking "unsubscribe" in the
                            Motor Tiger emails that are delivered to your email
                            address. You may modify your profile at any moment to
                            change your information.
                          </p>
                          <p>
                            <b>Other Websites' Links</b>
                          </p>
                          <p>
                            The Websites and Apps of Motor Tiger may contain links to
                            other websites or services that we do not maintain. This
                            Privacy Statement does not apply to third-party websites
                            that may be connected to our Websites or Apps. Even though
                            such services are branded as, or delivered on behalf of,
                            Motor Tiger, this Privacy Statement does not regulate the
                            actions of third parties, such as our partners,
                            third-party service providers, and/or advertising. Motor
                            Tiger has no control over or responsibility for the
                            security or privacy of those sites. Motor Tiger recommends
                            that you read the privacy policies on those sites.
                          </p>
                          <p>
                            <b>Privacy of Children</b>
                          </p>
                          <p>
                            All of our Services, including our Websites and Apps, are
                            aimed at adults and are not intended for children under
                            the age of 18 ("Children"). As a result, children under
                            the age of 18 are not permitted to access our Websites or
                            Apps. If you are under the age of 18, do not attempt to
                            register for or use any of our Services, including our
                            Websites and Apps, or supply us with any Personal
                            Information.
                            <br />
                            We do not collect Personal Information from children under
                            the age of 18. Please notify us if you are a parent or
                            guardian and believe your kid has violated this Privacy
                            Statement by providing us with Personal Information. If we
                            learn that we have obtained Personal Information from
                            children without parental consent, we will take measures
                            to erase the data from our systems.
                          </p>
                          <p>
                            <b>Changes to this Privacy Statement</b>
                          </p>
                          <p>
                            Motor Tiger reserves the right to change this Privacy
                            Statement at any moment. Motor Tiger will notify you of
                            any major changes to its Privacy Statement by revising the
                            Privacy Statement modification date above and displaying
                            the changes on this website. Motor Tiger encourages you to
                            visit this website for changes on a regular basis.
                          </p>
                          <p>
                            <b>Providing Motor Tiger with a Verifiable Request</b>
                          </p>
                          <p>
                            As previously stated, California citizens have specific
                            rights to access, remove, or otherwise restrict their
                            information's use, acquisition, and/or distribution. Motor
                            Tiger will react to a "verifiable request" from an
                            individual to exercise his or her rights under such laws -
                            that is, where Motor Tiger receives a request purporting
                            to be from a specific individual and Motor Tiger is able
                            to authenticate the subject's identification. The
                            necessity to authenticate an individual's identification
                            is vital for protecting your information and ensuring that
                            it is not shared with someone posing as you or acting on
                            your behalf who is not allowed to do so.
                            <br />
                            <br />
                            You may make a verified request using our website, or the
                            toll-free number indicated below in the "How to Contact Us
                            for CCPA Requests" section, or as otherwise stated on our
                            Websites and Apps (if such means are available). As part
                            of the process, Motor Tiger will ask you for personal
                            information so that we can verify your identification.
                            This information might include your name, address, account
                            information, and any other information Motor Tiger deems
                            essential to fairly authenticate your identification and
                            prevent your information from being shared with someone
                            impersonating you. We will work quickly to fulfill your
                            request after confirming your identification.
                            <br />
                            <br />
                            Please keep in mind that there may be times when we are
                            unable to complete your request, such as when we are
                            unable to locate any information on you inside your
                            systems. In some cases, such as when your information is
                            required to fulfill your order with us or to comply with a
                            legal requirement, we may not be able to comply with your
                            deletion request. We'll let you know whether we can
                            accommodate your request for rights.
                            <br />
                            <br />
                            If we have trouble establishing your identity, we may ask
                            for more information. In the event that we are unable to
                            authenticate your identity, we will not release your
                            information or honor other requests. A consumer can
                            appoint an "authorized agent" under California law to make
                            certain verified requests on their behalf, such as the
                            right to know what information we gather about them or the
                            right to have their information deleted. We will ask you
                            to identify and provide written consent for such people to
                            serve as your authorized agent and exercise your
                            applicable rights under California law in such cases since
                            the security and privacy of your information is vital.
                            This may necessitate us contacting you directly to warn
                            you that someone claiming to be your agent is attempting
                            to access or delete your data.
                            <br />
                            <br />
                            We will also independently verify your identification to
                            guarantee that no one else is impersonating you and
                            exercising your rights without your permission. If you
                            cannot or will not obtain authorization in writing for an
                            identified authorized agent to act on your behalf, or if
                            we cannot independently authenticate your identity, we
                            will not release your information or satisfy any other
                            requests.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            GENERAL, KEY TERMS &amp; CONDITION:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            <b>REPLACEMENT PARTS (INCLUDING ENGINE):</b> The engine
                            must be installed within 7 business days of its receipt. A
                            new thermostat and timing belt must be installed at the
                            time of engine installation. Any claims occurring prior to
                            receiving such funds will be considered pre-existing and
                            will not be covered. In case of a total breakdown of a
                            part or engine, the administrator's obligation is limited
                            to repairing or replacing broken covered components. It is
                            the administrator's decision to replace the engine or to
                            replace part(s) that are covered under this contract. If
                            replacement of an engine is required and a replacement
                            engine is not available we reserve the right to pay in
                            cash the cost of replacement engine's value. If the engine
                            needs to be replaced under the coverage of this contract,
                            MT has the option to replace the said engine with another
                            used assembly of like kind and quality, or paying the
                            contract holder the MT wholesale replacement engine cost.
                            MT will not be responsible for any freight cost incurred.
                            Replacement of any parts or engine will be done only once
                            under this contract.
                          </p>
                          <p>
                            <b>TRANSFERABILITY:</b> This product warranty is not
                            transferable to another purchaser or another engine
                          </p>
                          <p>
                            <b>ADMINISTRATOR'S RIGHTS TO TERMINATE BENEFITS:</b> In
                            the event of a claim, administrator reserves the right to
                            terminate the benefits of this product warranty upon the
                            discovery of fraud or misrepresentation of a material fact
                            by the purchaser or the purchaser's representative.
                            Evidence of fraud or misrepresentation is forwarded to the
                            proper state and federal authorities. Any vehicle used in
                            the commission of a crime will have all benefits
                            terminated.
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            MAINTENANCE REQUIREMENTS:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <ul style={{ listStyle: "none" }}>
                            <li>
                              1. Change oil per Manufacturer Requirements, whichever
                              comes first after the initial oil change and product
                              installation. This must be done by a commercial
                              facility.{" "}
                            </li>
                            <li>
                              2. Purchaser may not have their required maintenance
                              performed by a service facility that is owned or
                              operated by the purchaser. Purchasers cannot perform
                              their own maintenance for product warranty requirements.{" "}
                            </li>
                            <li>
                              3. Acceptable records documenting purchaser's adherence
                              to the vehicle manufacturer's required maintenance are
                              required in the event of a claim.{" "}
                            </li>
                            <li>
                              4. Acceptable records must be: issued on the date of
                              maintenance, issued in the name of purchaser, be signed
                              by purchaser, be electronically generated, issued by the
                              commercial lubrication service facility performing the
                              maintenance, include mileage, date, vehicle
                              identification number, year, make, and model, and
                              include a record of payment and service performed. Any
                              handwritten information on records, receipts or repair
                              orders, pertaining to or documenting required
                              maintenance are not acceptable.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            EXCLUSIONS:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <ul style={{ listStyle: "none" }}>
                            <li>
                              1. Breakdown or failure of any listed covered component
                              prior to benefit activation is not covered.{" "}
                            </li>
                            <li>
                              2. Any and all claims or damage resulting from: abuse,
                              negligence, freezing, overheating of any type, failure
                              to maintain proper coolant, fluid, refrigerant, or
                              lubrication levels, personal damages, per diem expenses,
                              storage fees, medical expenses, telephone or rental
                              charges, fire, flood, vandalism, theft, collision, acts
                              of GOD, competition or racing, usages not approved by
                              the vehicle manufacturer, improper load capacity, or
                              improper towing, damages caused by contaminated fluids,
                              coolants, or lubricants for any reason, misuse, road
                              conditions, riots or acts of war. Excessive oil
                              consumption and diminished performance are not covered.
                              Leaking seals, gaskets or fittings are not covered.
                              Vehicle components that require normal manufacturers
                              recommended replacement intervals are not covered.
                              Benefits are not active until all applicable fees or
                              installment payment plan confirmation has been received
                              by the administrator. Benefits are not active until the
                              customer calls to activate warranty{" "}
                            </li>
                            <li>
                              3. Pre-existing conditions and problems that occur prior
                              to the benefit activation date and mileage are not
                              covered. Covered components that are worn or burned but
                              NOT broken are not covered. Broken covered components
                              are defined as components that have cracked or separated
                              into pieces. Covered components that are flaking or have
                              been damaged by excessive heat or scoring are not
                              covered.{" "}
                            </li>
                            <li>
                              4. Any component not listed as a covered component, is
                              not covered. Damage to a covered component due to
                              non-covered component failure is not covered.{" "}
                            </li>
                            <li>
                              5. Vehicles with: a non-functioning odometer, a diesel
                              engine manufactured before 1990, a rotary engine,
                              alterations not approved by the manufacturer including,
                              but not limited to, oversized or undersized tires and
                              lift kits, and vehicles used for commercial purposes are
                              not eligible for coverage under this product warranty.
                            </li>
                            <li>
                              6. Claims occurring outside the United States are not
                              covered.{" "}
                            </li>
                            <li>
                              7. Once a claim has been initiated, the purchaser may
                              not continue to operate the vehicle until a claim
                              decision has been made. Continued operation will void
                              the claim.
                            </li>
                            <li>
                              8. Any work or repair done to vehicle without prior
                              written authorization from administrator is not
                              considered an authorized claim.{" "}
                            </li>
                            <li>
                              9. Warranty will void if the part is used for racing,
                              operated without proper fluids, or a melted heat tab.
                            </li>
                            <li>
                              10. Freight is not paid under this contract on any parts
                              or engine claims.{" "}
                            </li>
                            <li>
                              11. Towing &amp; diagnostic charges are not paid under
                              this contract.
                            </li>
                            <li>
                              12. Breakdown or failure means totally inoperable. It
                              does not mean a decrease or gradual reduction in the
                              parts performance due to normal or abnormal wear and
                              tear.{" "}
                            </li>
                            <li>
                              13. Breakdown caused by mechanical alterations not
                              meeting manufacturer's specifications.{" "}
                            </li>
                            <li>14. Breakdowns covered by factory recall. </li>
                            <li>
                              15. Any covered part which is not broken or inoperable,
                              which a repair facility recommends or required to be
                              repaired or replaced.{" "}
                            </li>
                            <li>
                              16. Breakdowns to a covered part already replaced under
                              the contract.{" "}
                            </li>
                            <li>
                              17. Liability for tear down is the customer's
                              responsibility.{" "}
                            </li>
                            <li>
                              18. Defective parts must be made available for
                              inspection upon the claims administrator's MT{" "}
                            </li>
                            <li>
                              19. Breakdown caused by excessive wear and tear for the
                              year and mileage of vehicle are not covered under this
                              contract.{" "}
                            </li>
                            <li>
                              20. Warranty is voided if heat tab is melted, or if
                              engine has no heat tab at time of claim.{" "}
                            </li>
                            <li>
                              21. Breakdowns covered by manufacturer warranty or
                              recall, distributor or repairers guarantee, any other
                              written warranty, government or court orders, decrees or
                              settlements, or any valid or collectable insurance
                              policy.{" "}
                            </li>
                            <li>22. Improper engine installation. </li>
                            <li>
                              23. We do not warranty oil leaks/damage on engines or
                              transmissions due to non-replaced seals, gaskets or
                              filters.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            SHIPPING INFORMATION:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <p>
                            You must provide a valid working phone number prior to
                            your shipment leaving, if you do not provide this, your
                            shipment will be delayed Shipping/delivery times: We ship
                            products within 7 - 14 business days. We do not offer. We
                            charge accordingly depending on your location. Please
                            email / call us with your zip code / postal code so that
                            we may be able to get an accurate shipping quote for you.
                            <br />
                            Important note: Do not sign the release documents without
                            fully inspecting the outer packaging for noticeable signs
                            of damage. the freight companies will not let you open up
                            the packaging prior to signing, therefore you must note
                            any signs of damage based on the external packaging,
                            shipping insurance is provided by the freight company, not
                            by MT if you sign the form and do not note any possible
                            damages, the freight company will be relieved of all
                            responsibility and you will not be reimbursed for any
                            damages done to your shipment caused during shipping. You
                            must notify MT of any damages caused by mishandling during
                            shipping; once again, please do not sign the release form
                            or et the driver leave without first inspecting the
                            packaging for possible damages.
                          </p>
                          <p>
                            <b>MOTOR TIGER INC.</b> utilizes UPS and FedEx for most
                            shipped items. In most cases, your order will be packed
                            and shipped within 48 -72 business hours. Larger items,
                            such as motors, transmissions, hoods, and doors require a
                            different method of shipping. We use several carriers
                            offering you the best rates and delivery times. We get
                            very competitive rates throughout the country. Here are
                            some guidelines to keep in mind if you are unable to get
                            the weight of your part: Smaller parts are easy to UPS and
                            must be less than 150 lbs. and under certain dimensions.
                            All weights are guidelines and subject to change with each
                            vehicle.
                          </p>
                          <ul style={{ listStyle: "none" }}>
                            <li>1 Taillights: 10 lbs. </li>
                            <li>2. Headlights: 13 lbs. </li>
                            <li>3. AC Compressors: 26 lbs. </li>
                            <li>4. Power Steering Pumps: 15 lbs. </li>
                            <li>5. Radios: 12 lbs. </li>
                            <li>6. Alternators: 17 lbs. </li>
                            <li>7. Starters: 17 lbs. </li>
                            <li>8. Modules, Brain Boxes, ECUs: 10 lbs. </li>
                            <li>9. Mirrors: 15 lbs. </li>
                            <li>10. Radiator: 20-50 lbs. </li>
                            <li>11. Wheel: 20-50 lbs. </li>
                            <li>12. Wheel Cover: 13 lbs. </li>
                            <li>13. Transfer case: 90 lbs. </li>
                            <li>14. Drive axles: 25-60 lbs.</li>
                            <li>
                              15. Airbags require special boxes and higher
                              regulations.
                            </li>
                          </ul>
                          <p>
                            <b>Cancellation terms and conditions</b>
                          </p>
                          <ul>
                            <li>
                              Orders can be cancelled only before they are shipped. If
                              you cancel an order before shipment, you will be liable
                              for all shipping charges and a 35% - 45% restocking fee.
                            </li>
                            <li>
                              Once the order has been shipped, cancellation is no
                              longer possible. Once the auto part leaves our facility,
                              it cannot be cancelled. If Cancelled amount will not be
                              refunded.
                            </li>
                          </ul>
                          <p>
                            <b>No Refund on Shipping terms and conditions</b>
                          </p>
                          <ul>
                            <li>
                              Shipping charges are non-refundable. The customer will
                              be responsible for any additional shipping costs,
                              including extra charges incurred during delivery.{" "}
                            </li>
                            <li>
                              Only the cost of the part is refunded in the event of a
                              return or refund request. Shipping costs and related
                              expenses will not be reimbursed.
                            </li>
                          </ul>
                          <p>
                            Customer is responsible for fulfilling the terms of
                            payment. If customer defaults on the payment terms he/she
                            will be responsible for all of the charges associated with
                            collection. These charges will include all collection
                            costs and attorney fees.
                          </p>
                          <ul>
                            <li>
                              Wrong parts ordered or parts that we're not diagnosed
                              correctly are non-refundable.
                            </li>
                            <li>
                              Falsifying any information will automatically void your
                              warranty.
                            </li>
                          </ul>
                          <p>
                            Please note that you are purchasing used part! We do our
                            best to make the part as presentable as possible but we
                            make no guarantees towards the appearance of it. Outside
                            appearance is not guaranteed as per our warranty terms.
                          </p>
                          <ul>
                            <li>
                              Please inspect all the parts before signing on delivery
                            </li>
                          </ul>
                          <p>
                            The mileage stated is approximate whenever is available to
                            the best of our knowledge replaced.{" "}
                            <b>
                              (Deposits made to us are non-refundable unless otherwise
                              noted).{" "}
                            </b>
                            <br />
                            <br />
                            If return or exchange was authorized by MT, the part needs
                            to be received in the same assembled condition as it was
                            originally shipped to the customer. If the part is not
                            received in the same condition there will be absolutely{" "}
                            <b>NO REFUND </b>under any circumstances.
                            <br />
                            <br />
                            Refunds are only authorized if replacement is not
                            available. If the engine was disassembled or altered in
                            any way without MT written authorization the warranty will
                            be void.
                            <br />
                            <br />
                            <b>
                              Engines are run tested, visually inspected and cleaned.
                            </b>
                          </p>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-25d909b elementor-widget elementor-widget-heading"
                        data-id="25d909b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            WARRANTY WILL BE VOID IF:
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-245c268 elementor-widget elementor-widget-text-editor"
                        data-id="245c268"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          <ul>
                            <li>Engine was not properly installed</li>
                            <li>Engine was used for racing.</li>
                            <li>Custom installation parts carry no warranty.</li>
                            <li>
                              Vehicles modified in any way outside manufacturer's
                              specifications.
                            </li>
                            <li>
                              Engine was used without proper lubrication or cooling
                              regardless of the reason.
                            </li>
                            <li>
                              Engine is not installed within 7 Business days after
                              delivery.
                            </li>
                            <li>
                              MT warranty will cover only a one-time claim per product
                              purchased from us.
                            </li>
                            <li>
                              MT warranty claim representative will work with you to
                              ensure your experience is a complete success.
                            </li>
                          </ul>
                          <p>
                            We reserve the right to charge any applicable fees in
                            connection with processing of your warranty claim.
                            <br />
                            <br />
                            MT warrants the original purchaser only. We guarantee that
                            any used engine sold by MT shall be free from knocking,
                            excessive oil consumption and cracks in the block, and is
                            subject to the abovementioned terms and conditions.
                            <br />
                            <br />
                            In case of Disagreement or objection or any changes with
                            respect to information and contents mentioned hereinabove,
                            please contact our toll free number +1-(877) 473-7675 OR
                            you can write us at info@motortiger.com &amp; register
                            your objections/changes/disagreement to the contents of
                            this transcript or you may also send us email or written
                            correspondence at the following details within a period of
                            7 days from date of your receipt.
                            <br />
                            <br />
                            I/we have read and understood the Policy of your Company
                            at www.motortiger.com and I hereby unconditionally agree
                            and bind myself to all terms and conditions of your
                            Policy, as amended, from time to time.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <footer
              itemType="https://schema.org/WPFooter"
              itemScope="itemscope"
              id="colophon"
              role="contentinfo"
            >
              <div className="footer-width-fixer">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id={4877}
                  className="elementor elementor-4877"
                >
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-20e36918 elementor-section-height-min-height elementor-section-content-middle elementor-section-full_width elementor-section-height-default elementor-section-items-middle"
                    data-id="20e36918"
                    data-element_type="section"
                    data-settings='{"background_background":"classic","_ha_eqh_enable":false}'
                  >
                    <div className="elementor-background-overlay" />
                    <div className="elementor-container elementor-column-gap-default">
                      <div
                        className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-23bdfb49"
                        data-id="23bdfb49"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <section
                            className="elementor-section elementor-inner-section elementor-element elementor-element-7c886fc8 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                            data-id="7c886fc8"
                            data-element_type="section"
                            data-settings='{"_ha_eqh_enable":false}'
                          >
                            <div className="elementor-container elementor-column-gap-default">
                              <div
                                className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-1c9e2524"
                                data-id="1c9e2524"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-6959151 elementor-widget elementor-widget-heading"
                                    data-id={6959151}
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h2 className="elementor-heading-title elementor-size-default">
                                        Address
                                      </h2>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-0f5b7c2 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                    data-id="0f5b7c2"
                                    data-element_type="widget"
                                    data-widget_type="icon-list.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <link
                                        rel="stylesheet"
                                        href="https://motortiger.com/wp-content/plugins/elementor/assets/css/widget-icon-list.min.css"
                                      />
                                      <ul className="elementor-icon-list-items">
                                        <li className="elementor-icon-list-item">
                                          <span className="elementor-icon-list-icon">
                                            <i
                                              aria-hidden="true"
                                              className="hm hm-pin"
                                            />{" "}
                                          </span>
                                          <span className="elementor-icon-list-text">
                                            6000 Big Pine Dr, Fontana, CA 92336,
                                            United States
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-89c9778 elementor-shape-circle e-grid-align-left elementor-grid-0 elementor-widget elementor-widget-social-icons"
                                    data-id="89c9778"
                                    data-element_type="widget"
                                    data-widget_type="social-icons.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <style
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            "\n                                                                        /*! elementor - v3.22.0 - 26-06-2024 */\n                                                                        .elementor-widget-social-icons.elementor-grid-0 .elementor-widget-container,\n                                                                        .elementor-widget-social-icons.elementor-grid-mobile-0 .elementor-widget-container,\n                                                                        .elementor-widget-social-icons.elementor-grid-tablet-0 .elementor-widget-container {\n                                                                            line-height: 1;\n                                                                            font-size: 0\n                                                                        }\n\n                                                                        .elementor-widget-social-icons:not(.elementor-grid-0):not(.elementor-grid-tablet-0):not(.elementor-grid-mobile-0) .elementor-grid {\n                                                                            display: inline-grid\n                                                                        }\n\n                                                                        .elementor-widget-social-icons .elementor-grid {\n                                                                            grid-column-gap: var(--grid-column-gap, 5px);\n                                                                            grid-row-gap: var(--grid-row-gap, 5px);\n                                                                            grid-template-columns: var(--grid-template-columns);\n                                                                            justify-content: var(--justify-content, center);\n                                                                            justify-items: var(--justify-content, center)\n                                                                        }\n\n                                                                        .elementor-icon.elementor-social-icon {\n                                                                            font-size: var(--icon-size, 25px);\n                                                                            line-height: var(--icon-size, 25px);\n                                                                            width: calc(var(--icon-size, 25px) + 2 * var(--icon-padding, .5em));\n                                                                            height: calc(var(--icon-size, 25px) + 2 * var(--icon-padding, .5em))\n                                                                        }\n\n                                                                        .elementor-social-icon {\n                                                                            --e-social-icon-icon-color: #fff;\n                                                                            display: inline-flex;\n                                                                            background-color: #69727d;\n                                                                            align-items: center;\n                                                                            justify-content: center;\n                                                                            text-align: center;\n                                                                            cursor: pointer\n                                                                        }\n\n                                                                        .elementor-social-icon i {\n                                                                            color: var(--e-social-icon-icon-color)\n                                                                        }\n\n                                                                        .elementor-social-icon svg {\n                                                                            fill: var(--e-social-icon-icon-color)\n                                                                        }\n\n                                                                        .elementor-social-icon:last-child {\n                                                                            margin: 0\n                                                                        }\n\n                                                                        .elementor-social-icon:hover {\n                                                                            opacity: .9;\n                                                                            color: #fff\n                                                                        }\n\n                                                                        .elementor-social-icon-android {\n                                                                            background-color: #a4c639\n                                                                        }\n\n                                                                        .elementor-social-icon-apple {\n                                                                            background-color: #999\n                                                                        }\n\n                                                                        .elementor-social-icon-behance {\n                                                                            background-color: #1769ff\n                                                                        }\n\n                                                                        .elementor-social-icon-bitbucket {\n                                                                            background-color: #205081\n                                                                        }\n\n                                                                        .elementor-social-icon-codepen {\n                                                                            background-color: #000\n                                                                        }\n\n                                                                        .elementor-social-icon-delicious {\n                                                                            background-color: #39f\n                                                                        }\n\n                                                                        .elementor-social-icon-deviantart {\n                                                                            background-color: #05cc47\n                                                                        }\n\n                                                                        .elementor-social-icon-digg {\n                                                                            background-color: #005be2\n                                                                        }\n\n                                                                        .elementor-social-icon-dribbble {\n                                                                            background-color: #ea4c89\n                                                                        }\n\n                                                                        .elementor-social-icon-elementor {\n                                                                            background-color: #d30c5c\n                                                                        }\n\n                                                                        .elementor-social-icon-envelope {\n                                                                            background-color: #ea4335\n                                                                        }\n\n                                                                        .elementor-social-icon-facebook,\n                                                                        .elementor-social-icon-facebook-f {\n                                                                            background-color: #3b5998\n                                                                        }\n\n                                                                        .elementor-social-icon-flickr {\n                                                                            background-color: #0063dc\n                                                                        }\n\n                                                                        .elementor-social-icon-foursquare {\n                                                                            background-color: #2d5be3\n                                                                        }\n\n                                                                        .elementor-social-icon-free-code-camp,\n                                                                        .elementor-social-icon-freecodecamp {\n                                                                            background-color: #006400\n                                                                        }\n\n                                                                        .elementor-social-icon-github {\n                                                                            background-color: #333\n                                                                        }\n\n                                                                        .elementor-social-icon-gitlab {\n                                                                            background-color: #e24329\n                                                                        }\n\n                                                                        .elementor-social-icon-globe {\n                                                                            background-color: #69727d\n                                                                        }\n\n                                                                        .elementor-social-icon-google-plus,\n                                                                        .elementor-social-icon-google-plus-g {\n                                                                            background-color: #dd4b39\n                                                                        }\n\n                                                                        .elementor-social-icon-houzz {\n                                                                            background-color: #7ac142\n                                                                        }\n\n                                                                        .elementor-social-icon-instagram {\n                                                                            background-color: #262626\n                                                                        }\n\n                                                                        .elementor-social-icon-jsfiddle {\n                                                                            background-color: #487aa2\n                                                                        }\n\n                                                                        .elementor-social-icon-link {\n                                                                            background-color: #818a91\n                                                                        }\n\n                                                                        .elementor-social-icon-linkedin,\n                                                                        .elementor-social-icon-linkedin-in {\n                                                                            background-color: #0077b5\n                                                                        }\n\n                                                                        .elementor-social-icon-medium {\n                                                                            background-color: #00ab6b\n                                                                        }\n\n                                                                        .elementor-social-icon-meetup {\n                                                                            background-color: #ec1c40\n                                                                        }\n\n                                                                        .elementor-social-icon-mixcloud {\n                                                                            background-color: #273a4b\n                                                                        }\n\n                                                                        .elementor-social-icon-odnoklassniki {\n                                                                            background-color: #f4731c\n                                                                        }\n\n                                                                        .elementor-social-icon-pinterest {\n                                                                            background-color: #bd081c\n                                                                        }\n\n                                                                        .elementor-social-icon-product-hunt {\n                                                                            background-color: #da552f\n                                                                        }\n\n                                                                        .elementor-social-icon-reddit {\n                                                                            background-color: #ff4500\n                                                                        }\n\n                                                                        .elementor-social-icon-rss {\n                                                                            background-color: #f26522\n                                                                        }\n\n                                                                        .elementor-social-icon-shopping-cart {\n                                                                            background-color: #4caf50\n                                                                        }\n\n                                                                        .elementor-social-icon-skype {\n                                                                            background-color: #00aff0\n                                                                        }\n\n                                                                        .elementor-social-icon-slideshare {\n                                                                            background-color: #0077b5\n                                                                        }\n\n                                                                        .elementor-social-icon-snapchat {\n                                                                            background-color: #fffc00\n                                                                        }\n\n                                                                        .elementor-social-icon-soundcloud {\n                                                                            background-color: #f80\n                                                                        }\n\n                                                                        .elementor-social-icon-spotify {\n                                                                            background-color: #2ebd59\n                                                                        }\n\n                                                                        .elementor-social-icon-stack-overflow {\n                                                                            background-color: #fe7a15\n                                                                        }\n\n                                                                        .elementor-social-icon-steam {\n                                                                            background-color: #00adee\n                                                                        }\n\n                                                                        .elementor-social-icon-stumbleupon {\n                                                                            background-color: #eb4924\n                                                                        }\n\n                                                                        .elementor-social-icon-telegram {\n                                                                            background-color: #2ca5e0\n                                                                        }\n\n                                                                        .elementor-social-icon-threads {\n                                                                            background-color: #000\n                                                                        }\n\n                                                                        .elementor-social-icon-thumb-tack {\n                                                                            background-color: #1aa1d8\n                                                                        }\n\n                                                                        .elementor-social-icon-tripadvisor {\n                                                                            background-color: #589442\n                                                                        }\n\n                                                                        .elementor-social-icon-tumblr {\n                                                                            background-color: #35465c\n                                                                        }\n\n                                                                        .elementor-social-icon-twitch {\n                                                                            background-color: #6441a5\n                                                                        }\n\n                                                                        .elementor-social-icon-twitter {\n                                                                            background-color: #1da1f2\n                                                                        }\n\n                                                                        .elementor-social-icon-viber {\n                                                                            background-color: #665cac\n                                                                        }\n\n                                                                        .elementor-social-icon-vimeo {\n                                                                            background-color: #1ab7ea\n                                                                        }\n\n                                                                        .elementor-social-icon-vk {\n                                                                            background-color: #45668e\n                                                                        }\n\n                                                                        .elementor-social-icon-weibo {\n                                                                            background-color: #dd2430\n                                                                        }\n\n                                                                        .elementor-social-icon-weixin {\n                                                                            background-color: #31a918\n                                                                        }\n\n                                                                        .elementor-social-icon-whatsapp {\n                                                                            background-color: #25d366\n                                                                        }\n\n                                                                        .elementor-social-icon-wordpress {\n                                                                            background-color: #21759b\n                                                                        }\n\n                                                                        .elementor-social-icon-x-twitter {\n                                                                            background-color: #000\n                                                                        }\n\n                                                                        .elementor-social-icon-xing {\n                                                                            background-color: #026466\n                                                                        }\n\n                                                                        .elementor-social-icon-yelp {\n                                                                            background-color: #af0606\n                                                                        }\n\n                                                                        .elementor-social-icon-youtube {\n                                                                            background-color: #cd201f\n                                                                        }\n\n                                                                        .elementor-social-icon-500px {\n                                                                            background-color: #0099e5\n                                                                        }\n\n                                                                        .elementor-shape-rounded .elementor-icon.elementor-social-icon {\n                                                                            border-radius: 10%\n                                                                        }\n\n                                                                        .elementor-shape-circle .elementor-icon.elementor-social-icon {\n                                                                            border-radius: 50%\n                                                                        }\n                                                                    "
                                        }}
                                      />
                                      <div className="elementor-social-icons-wrapper elementor-grid">
                                        <span className="elementor-grid-item">
                                          <a
                                            className="elementor-icon elementor-social-icon elementor-social-icon-facebook elementor-repeater-item-ae880e4"
                                            href="https://www.facebook.com/people/MotorTiger/61554914125745/"
                                            target="_blank"
                                          >
                                            <span className="elementor-screen-only">
                                              Facebook
                                            </span>
                                            <svg
                                              className="e-font-icon-svg e-fab-facebook"
                                              viewBox="0 0 512 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
                                            </svg>{" "}
                                          </a>
                                        </span>
                                        <span className="elementor-grid-item">
                                          <a
                                            className="elementor-icon elementor-social-icon elementor-social-icon-instagram elementor-repeater-item-6093371"
                                            href="https://www.instagram.com/motortigerofficial/"
                                            target="_blank"
                                          >
                                            <span className="elementor-screen-only">
                                              Instagram
                                            </span>
                                            <svg
                                              className="e-font-icon-svg e-fab-instagram"
                                              viewBox="0 0 448 512"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                                            </svg>{" "}
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-756601bc"
                                data-id="756601bc"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-755ef9bb elementor-widget elementor-widget-heading"
                                    data-id="755ef9bb"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h2 className="elementor-heading-title elementor-size-default">
                                        Contact
                                      </h2>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-3eaf4fd7 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                    data-id="3eaf4fd7"
                                    data-element_type="widget"
                                    data-widget_type="icon-list.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <ul className="elementor-icon-list-items">
                                        <li className="elementor-icon-list-item">
                                          <a href="mailto:info@motortiger.com">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-mail-open"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              info@motortiger.com
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="tel:+1(855) 253-1634">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-phone"
                                              />{" "}
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              +1 (855) 253-1634
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="tel:+1(877)-473-7675">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-phone"
                                              />{" "}
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              +1 (877)-473-7675
                                            </span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-34ff468a"
                                data-id="34ff468a"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-60ca8698 elementor-widget elementor-widget-heading"
                                    data-id="60ca8698"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h2 className="elementor-heading-title elementor-size-default">
                                        Quick Links
                                      </h2>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-d490265 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                    data-id="d490265"
                                    data-element_type="widget"
                                    data-widget_type="icon-list.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <ul className="elementor-icon-list-items">
                                        <li className="elementor-icon-list-item">
                                          <a href="/about">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              About Us
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/contact">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Contact
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/used-engines">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Used Engines
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/used-transmissions">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Used Transmissions
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/used-auto-spare-parts">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Used Auto Spare Parts
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/rebuilt-engines">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Rebuilt Engines
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/rebuilt-transmissions">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Rebuilt Transmissions
                                            </span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-6db68d83"
                                data-id="6db68d83"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-684434f elementor-widget elementor-widget-heading"
                                    data-id="684434f"
                                    data-element_type="widget"
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h2 className="elementor-heading-title elementor-size-default">
                                        Customer Service
                                      </h2>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-bc4f1fc elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                                    data-id="bc4f1fc"
                                    data-element_type="widget"
                                    data-widget_type="icon-list.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <ul className="elementor-icon-list-items">
                                        <li className="elementor-icon-list-item">
                                          <a href="/privacy-policy">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Privacy Policy
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/return-policy">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Return, Cancellaton & Shipping Policy
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="shipping-policy.1.html">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Shipping Policy
                                            </span>
                                          </a>
                                        </li>
                                        <li className="elementor-icon-list-item">
                                          <a href="/warranty-policyl">
                                            <span className="elementor-icon-list-icon">
                                              <i
                                                aria-hidden="true"
                                                className="hm hm-webcam2"
                                              />
                                            </span>
                                            <span className="elementor-icon-list-text">
                                              Warranty Policy
                                            </span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <section
                            className="elementor-section elementor-inner-section elementor-element elementor-element-1a310ad3 elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                            data-id="1a310ad3"
                            data-element_type="section"
                            data-settings='{"_ha_eqh_enable":false}'
                          >
                            <div className="elementor-container elementor-column-gap-default">
                              <div
                                className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-75a56272"
                                data-id="75a56272"
                                data-element_type="column"
                              >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                  <div
                                    className="elementor-element elementor-element-6d2b3f9d elementor-widget elementor-widget-text-editor"
                                    data-id="6d2b3f9d"
                                    data-element_type="widget"
                                    data-widget_type="text-editor.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <p>
                                        Copyright 2024 – 2025 © Motortiger. All right
                                        reserved. Powered by Motortiger.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </footer>
          </div>
          {/* #page */}
        </div>
        {/* #page */}
      </>

    </div>
  );
};

export default WarrentyPolicy;